<template>
    <b-modal
            body-class="p-0"
            cancel-disabled
            hide-footer
            id="in-warranty-device-exists-modal"
            title="">
        <div class="modal-body modal-body-lg pt-0">
            <div>
                <animated-info class="mx-auto mb-4"></animated-info>
            </div>
            <h4 class="text-center mb-4">An in-warranty device is in your basket</h4>
            <p class="text-center mb-4">
                We can only repair one in-warranty device at a time. If you need to book in another device, please create a separate repair booking.
            </p>
            <p class="text-center">
                <button @click="$bvModal.hide('in-warranty-device-exists-modal')" class="btn btn-outline-dark btn-lg">Close</button>
            </p>
        </div>
    </b-modal>
</template>

<script>
    export default {
        methods: {

        }
    }
</script>

<style scoped>

</style>